import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFaireDirectBrand } from "@faire/retailer-visitor-shared/hooks/FaireDirect/useFaireDirectBrand/useFaireDirectBrand";
import { faireBaseUrl } from "@faire/web--source/common/routes/faireBaseUrl";
import { Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { Anchor } from "@faire/web--source/ui/LinkAnchor";
import { Link } from "@faire/web--source/ui/LinkAnchor";
import brandPath from "@faire/web-api--source/routes/brand/brandToken";
import * as React from "react";
import styled from "styled-components";
import { FaireX } from "../icons/FaireX";
export var FaireAndBrandLogo = function(param) {
    var brandName = param.brandName;
    var isMobile = useViewport().isMobile;
    var smallHeader = brandName.length > 30 || isMobile;
    var faireDirectBrandToken = useFaireDirectBrand().faireDirectBrandToken;
    return /*#__PURE__*/ _jsxs(Container, {
        children: [
            /*#__PURE__*/ _jsx(Anchor, {
                href: faireBaseUrl(),
                children: /*#__PURE__*/ _jsx(FaireX, {})
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "1x"
            }),
            /*#__PURE__*/ _jsx(Link, {
                to: brandPath(faireDirectBrandToken),
                children: /*#__PURE__*/ _jsx(BrandName, {
                    variant: smallHeader ? "subheadingSansRegular" : "pageHeaderSerifRegular",
                    children: brandName
                })
            })
        ]
    });
};
var Container = styled(Row).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-e2fa5c26-0"
})([
    ""
]);
var BrandName = styled(Typography).withConfig({
    componentId: "sc-e2fa5c26-1"
})([
    "&&&{margin-top:1px;}"
]);
